export default __webpack_public_path__ + "static/media/pictogramBeaconAccounts40.d0f57155.svg";